import { DEFAULT_STARKNET_TYPED_DATA_DOMAIN } from '../wallets/constants.js';

const bufferToBase64 = (buf) => {
    const binstr = Array.prototype.map
        .call(buf, (ch) => String.fromCharCode(ch))
        .join('');
    return btoa(binstr);
};
const defaultTypedData = Object.assign(Object.assign({}, DEFAULT_STARKNET_TYPED_DATA_DOMAIN), { primaryType: 'Message', types: {
        Message: [
            {
                name: 'message',
                type: 'felt',
            },
        ],
        StarkNetDomain: [
            {
                name: 'name',
                type: 'felt',
            },
            {
                name: 'chainId',
                type: 'felt',
            },
            {
                name: 'version',
                type: 'felt',
            },
        ],
    } });
const formatTypedDataMessage = (inputMessage, chainId = 'SN_MAIN') => {
    const message = {
        message: inputMessage.substring(0, 31),
    };
    return Object.assign(Object.assign({}, defaultTypedData), { domain: Object.assign(Object.assign({}, defaultTypedData.domain), { chainId }), message });
};

export { bufferToBase64, formatTypedDataMessage };
